type ConfigTypes = {
  mapboxToken: string;
};

const Config: ConfigTypes = {
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN || "",
};

export default Config;
